/**
 * PackageTriggerLabel — the package picker's closed trigger: colour dot (or
 * package glyph) + name. The two-line option card would overflow the h-7
 * trigger.
 * For Media Devoted | Created By Ciro Autiero
 */

import type { FC } from 'react';
import { Package } from 'lucide-react';
import type { FlowOptimizerPackage } from '@trafficpulse/shared';

const PackageTriggerLabel: FC<{ pkg: FlowOptimizerPackage }> = ({ pkg }) => (
  <span className="flex min-w-0 items-center gap-1.5">
    {pkg.color ? (
      <span
        aria-hidden
        className="h-2 w-2 shrink-0 rounded-full"
        style={{ backgroundColor: pkg.color }}
      />
    ) : (
      <Package className="h-3 w-3 shrink-0 text-muted-foreground" aria-hidden />
    )}
    <span className="truncate font-medium">{pkg.name}</span>
  </span>
);

export default PackageTriggerLabel;
